import cn from 'classnames'

import { isWebView } from '@app/utils'

import { ConversationPlaceholder } from './ConversationPlaceholder'
import { DownloadPrompt } from './DownloadPrompt'
import styles from './styles.module.scss'
import { ConversationEmptyStateProps } from './types'

export const ConversationEmptyState = ({
  id = 'noChatSelected',
  mode = 'chat',
  isEmpty = false,
}: ConversationEmptyStateProps) => {
  const containerClassName = cn(styles.container, styles[mode])
  const shouldShowDownloadPrompt = !isWebView() && mode === 'chat' && !isEmpty

  return (
    <div className={containerClassName} id={id}>
      {!shouldShowDownloadPrompt ? (
        <ConversationPlaceholder mode={mode} isEmpty={isEmpty} />
      ) : null}

      <DownloadPrompt showPrompt={shouldShowDownloadPrompt} showModal={false} />
    </div>
  )
}
